import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";

import TagText from "../../ui/Tags/TagText";

const ProductsRenderer = ({ products = [] }) => {
  return (
    <Box display={"flex"} flexWrap={"wrap"} gridGap={"4px"}>
      {products.map(product => {
        return (
          <TagText key={product.name} intent={"primary"}>
            {product.name}
          </TagText>
        );
      })}
    </Box>
  );
};
ProductsRenderer.propTypes = {
  products: PropTypes.array,
};
export default ProductsRenderer;
